import { useEffect, useState } from 'react';
import {
  IconButton,
  type IconButtonProps,
  Snackbar,
  Tooltip,
} from '@mui/material';
import FullscreenRounded from '@mui/icons-material/FullscreenRounded';
import FullscreenExitRounded from '@mui/icons-material/FullscreenExitRounded';

/** Browser fullscreen control that also follows Escape and external fullscreen changes. */
export function FullscreenButton(
  props: Omit<IconButtonProps, 'onClick' | 'aria-label'>
) {
  const [fullscreen, setFullscreen] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    const update = () => setFullscreen(Boolean(document.fullscreenElement));
    update();
    document.addEventListener('fullscreenchange', update);
    return () => document.removeEventListener('fullscreenchange', update);
  }, []);
  const label = fullscreen ? 'Exit fullscreen' : 'Enter fullscreen';
  const toggle = async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch {
      setError(true);
    }
  };
  return (
    <>
      <Tooltip title={label}>
        <IconButton
          {...props}
          aria-label={label}
          aria-pressed={fullscreen}
          onClick={toggle}
        >
          {fullscreen ? <FullscreenExitRounded /> : <FullscreenRounded />}
        </IconButton>
      </Tooltip>
      <Snackbar
        open={error}
        autoHideDuration={5000}
        onClose={() => setError(false)}
        message="Fullscreen is unavailable. Try expanding your browser window."
      />
    </>
  );
}
export default FullscreenButton;
